export function AskAiIcon({ size = 16.5 }: { size?: number }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true">
      <path
        fill="currentColor"
        d="M12 3.2 13.1 8l4.9 1.1L13.1 10.2 12 15l-1.1-4.8L6 9.1 10.9 8z"
      />
      <path fill="currentColor" d="M18.2 13.2 18.8 15.6 21.2 16.2 18.8 16.8 18.2 19.2 17.6 16.8 15.2 16.2 17.6 15.6z" />
      <path fill="currentColor" d="M6.4 14.5 6.9 16.4 8.8 16.9 6.9 17.4 6.4 19.3 5.9 17.4 4 16.9 5.9 16.4z" />
    </svg>
  );
}
